import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/grupos/$")({
  beforeLoad: ({ params }) => {
    const rest = (params as { _splat?: string })._splat ?? "";
    throw redirect({ href: rest ? `/comunidades/${rest}` : "/comunidades", replace: true });
  },
  component: () => null,
});
